import FormatHelper from "@/core/helpers/formatHelper";

/**
 * Check whether the reminders configured for a renewal plan can be sent.
 *
 * Without any reminder there is nothing to send, so the configuration is valid.
 * A reminder sent by SMS needs a valid mobile phone number.
 *
 * @param config - The reminders configured and the channel they go through.
 *
 * @returns Whether the configuration can be published.
 */
export function renewalRemindersAreValid(config: {
    notifyRenewals: boolean;
    notifyCreated: boolean;
    channel: 'sms' | 'push';
    phone: string | null;
}): boolean {
    if (!config.notifyRenewals && !config.notifyCreated) {
        return true;
    }

    return config.channel !== 'sms' || FormatHelper.phoneIsValid(config.phone ?? '');
}
